import XLSX from "xlsx";
import { saveAs } from "file-saver";

function s2ab (s) {
  var buf = new ArrayBuffer(s.length); // convert s to arrayBuffer
  var view = new Uint8Array(buf); // create uint8array as viewer
  for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; // convert to octet
  return buf;
}

export default function excelExport (rowHeaders, rows, filename, props) {
  if (rowHeaders.length === 0) { return; }
  if (rows.length === 0) { return; }
  if (filename.length === 0) { return; }

  var wb = XLSX.utils.book_new();

  wb.Props = {
    Title: props.title,
    Subject: props.subject,
    Author: props.author,
    CreatedDate: new Date()
  };

  let date = new Date().toJSON().slice(0, 10);

  wb.SheetNames.push(date);

  rows.unshift(rowHeaders);

  let ws = XLSX.utils.aoa_to_sheet(rows);

  wb.Sheets[date] = ws;

  let wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

  saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), filename);
}
